'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useUnit } from 'effector-react';
import { trackLimitBlocksPopup, trackLimitNotesPopup } from '@nx-frontend/shared/analytics';
import { isFromCallPopupEnabled } from '@nx-frontend/shared/popups/from-call-popup';
import { $customizerPreviewFullscreen } from '@nx-frontend/shared/store/customizer-preview-store';
import { GetOpenPayWallPopupProps, PaywallPopupReason, PopupType } from '@nx-frontend/shared/types';
import { NextRouterType } from '@nx-frontend/shared/utils';
import { useNavHistoryHook } from '@nx-frontend/shared/utils';
import { Navbar } from './navbar';

export const getOpenPaywallPopup = ({ openModal, payload }: GetOpenPayWallPopupProps) => {
  let useFromCallUpgrade = false;
  if (typeof window !== 'undefined') {
    if ('on' === window.localStorage.getItem('useFromCallUpgrade')) {
      useFromCallUpgrade = isFromCallPopupEnabled;
    }
  }
  if (useFromCallUpgrade) {
    openModal({
      showCloseButton: false,
      content: PopupType.FROM_CALL,
      modalContainerStyles: 'bg-[#011519] !rounded-[12px]',
      modalGradient: 'linear-gradient(90deg, #001418 4.38%, #002028 59.57%, #001418 99.95%), #011519',
      usePadding: false,
      payload,
      multipopup: false,
    });
  } else {
    openModal({
      content: PopupType.PAYWALL,
      showCloseButton: false,
      isFullScreen: true,
      modalContainerStyles: 'bg-transparent',
      payload,
      multipopup: false,
      ...(payload && 'escapeToClose' in payload ? { escapeToClose: payload.escapeToClose } : {}),
    });
    if (payload?.reason) {
      switch (payload.reason) {
        case PaywallPopupReason.NOTES_LIMIT:
          trackLimitNotesPopup();
          break;
        case PaywallPopupReason.BLOCKS_LIMIT:
          trackLimitBlocksPopup();
          break;
      }
    }
  }
};

export function NavbarWrapper({ path }: { path: string }) {
  const router = useRouter();
  const pathname = usePathname();

  const [customizerPreviewFullscreen] = useUnit([$customizerPreviewFullscreen]);

  useNavHistoryHook(pathname);

  if (customizerPreviewFullscreen) return null;

  return (
    <div className="h-screen flex grow-0 shrink-0">
      <Navbar
        getOpenPaywallPopup={getOpenPaywallPopup}
        path={path}
        routerType={NextRouterType.APP}
        routerPushFn={router.push}
      />
    </div>
  );
}
